var $export = require('./_export')
  , $task   = require('./_task');
$export($export.G + $export.B, {
  setImmediate:   $task.set,
  clearImmediate: $task.clear
});


//////////////////
// WEBPACK FOOTER
// /var/www/umem/~/core-js/modules/web.immediate.js
// module id = 294
// module chunks = 0